module.exports = __webpack_public_path__ + "img/20210703_163849.f7ce5bf9.jpg";